import { getTestId } from '@airtel/air-design-system';
export var defaultProps = Object.assign({
  direction: 'vertical',
  size: 'sm',
  steps: [{
    heading: 'completed step',
    subHeading: '1 Jan 2023 at 12:45 pm',
    state: 'success'
  }, {
    heading: 'active step',
    subHeading: '1 Jan 2023 at 12:45 pm',
    state: 'default',
    stepNumber: '2'
  }, {
    heading: 'future step',
    state: 'disabled'
  }, {
    heading: 'future step',
    state: 'disabled'
  }]
}, getTestId('TrackOrderStepperWidgetContainer'));